// Mirrors HttpRequestAIActionValidationResult; names must match the backend's exactly.
export type ValidationCheckError = {
  are_all_parameters_assigned: boolean;
  are_external_badges_valid: boolean;
  are_parameter_names_not_empty: boolean;
  are_parameter_names_unique: boolean;
  are_parameters_not_more_than_max: boolean;
  are_body_items_names_unique: boolean;
  are_header_names_unique: boolean;
  are_query_items_names_unique: boolean;
  has_url: boolean;
  is_description_not_empty: boolean;
  is_name_not_empty: boolean;
  single_body_source: boolean;
  single_oauth_provider: boolean;
  no_unfilled_secret_placeholders: boolean;
};

const VALIDATION_CHECK_RULES: Array<[keyof ValidationCheckError, string]> = [
  ['has_url', 'actions_page:sheet.form.validation.url_required'],
  ['are_all_parameters_assigned', 'actions_page:sheet.form.validation.all_parameters_assigned'],
  ['are_header_names_unique', 'actions_page:sheet.form.validation.header_names_unique'],
  ['are_body_items_names_unique', 'actions_page:sheet.form.validation.body_items_names_unique'],
  ['are_query_items_names_unique', 'actions_page:sheet.form.validation.query_items_names_unique'],
  ['single_body_source', 'actions_page:sheet.form.validation.single_body_source'],
  ['are_external_badges_valid', 'actions_page:sheet.form.validation.external_badges_invalid'],
  ['single_oauth_provider', 'actions_page:sheet.form.validation.single_oauth_provider'],
  [
    'no_unfilled_secret_placeholders',
    'actions_page:sheet.form.validation.unfilled_secret_placeholders',
  ],
];

export const getValidationCheckMessage = (
  check: ValidationCheckError,
  t: (key: string) => string,
): string | null => {
  // Explicit false only: a key the backend omitted must fall through to the server's reason.
  const failedRule = VALIDATION_CHECK_RULES.find(([field]) => check[field] === false);
  return failedRule ? t(failedRule[1]) : null;
};
